module.exports = __webpack_public_path__ + "static/media/no-candidate-1800.97e7d519.jpg";